import { getConfigWithMetadata } from '@pkgs/api/utils/headers';
import { getErrorResult } from '@pkgs/api/utils';
import { type ApiConfig, type ApiResult } from '@pkgs/api/types';
import { customInstance } from '@generated/search-bff/custom-instance';
import { type WhatsAppLeadRequest, type WhatsAppLeadResponse } from '@generated/search-bff';

/**
 * Creates a WhatsApp lead and returns the wa.me redirect URL using the
 * `/api/v1/listing/{listingId}/lead/whatsapp` endpoint.
 */
export const createWhatsappLead = async (
  listingId: string,
  whatsAppLeadRequest: WhatsAppLeadRequest,
  apiConfig: ApiConfig,
): Promise<ApiResult<string>> => {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, 'createWhatsappLead');
    const data = await customInstance<WhatsAppLeadResponse>(
      {
        url: `/api/v1/listing/${listingId}/lead/whatsapp`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: whatsAppLeadRequest,
      },
      _apiConfig,
    );

    const redirectUrl = data.redirectUrl?.trim();
    if (!redirectUrl) {
      return getErrorResult(new Error('WhatsApp lead endpoint did not return a redirect URL'));
    }

    return {
      status: 'success',
      data: redirectUrl,
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
};
